// extracted by mini-css-extract-plugin
export default {"textInput":"styles_textInput__J5xZk","input":"styles_input__a9niw","textarea":"styles_textarea__CkU0a","mock":"styles_mock__vjFD9","hidden":"styles_hidden__dr6z-"};